import { createGlobalStyle } from 'styled-components';
import { FontFace } from './fontFace';
import { Colors } from '../app/constants/colors';
import { Fonts } from '../app/constants/fonts';

const GlobalStyle = createGlobalStyle`
  ${FontFace}
  body {
    margin: 0;
    padding: 0;
    background: ${Colors.background};
    color: ${Colors.text};
    font-family: ${Fonts.base};
    font-weight: 400;
    font-style: normal;

    * {
      box-sizing: border-box;
    }
  }

  h1, h2, h3, h4, h5 {
    font-family: ${Fonts.secondary};
  }

  html, body, #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  button {
    cursor: pointer;
  }
`;

export default GlobalStyle;
